export default "__VITE_ASSET__9k3GhYHd__"